import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  loading: false,
  error: null,
  successMessage: null,
  infoMessage: null,
};

// UI slice
const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.successMessage = null;
      state.infoMessage = null;
    },
    setSuccess: (state, action) => {
      state.successMessage = action.payload;
      state.error = null;
      state.infoMessage = null;
    },
    setInfo: (state, action) => {
      state.infoMessage = action.payload;
      state.error = null;
      state.successMessage = null;
    },
    clearMessages: (state) => {
      state.error = null;
      state.successMessage = null;
      state.infoMessage = null;
    },
  },
});

export const { setLoading, setError, setSuccess, setInfo, clearMessages } = uiSlice.actions;
export default uiSlice.reducer;
